<template>
  <section :id="$options.name" class="knowbefore">
    <h2 class="knowbefore__title">Informazioni importanti</h2>

    <b-alert class="knowbefore__alert" show>
      <p class="knowbefore__alert-title">Informazioni di sicurezza, sanitarie e doganali:</p>
      <span class="knowbefore__alert-description">
          se stai prenotando in una destinazione estera verifica prima le condizioni e i requisiti di viaggio sul sito
          <a class="knowbefore__alert-link" href="https://www.viaggiaresicuri.it/home" target="_blank">Viaggiare sicuri all’estero</a> del Governo italiano.
        </span>
    </b-alert>

    <div class="knowbefore__content">
      <template v-for="(block, key) in knowbefore_blocks">
        <component
          v-if="block.show"
          :key="_uid+block+key"
          :is="block.key"
          :property="property[block.key]"
        />
      </template>
    </div>
  </section>
</template>

<script>
import Attributes from "@liveeps/components/blocks/knowbefore/attributes"
import Fees from "@liveeps/components/blocks/knowbefore/fees"
import Policies from "@liveeps/components/blocks/knowbefore/policies"

export default {
  inheritAttrs: false,
  name: 'knowbefore',

  components: {
    'attributes': Attributes,
    'fees': Fees,
    'policies': Policies,
  },

  props: {
    property: Object,
  },

  data() {
    return {
      knowbefore_blocks: [],
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    this.knowbefore_blocks = [
      {
        key: "policies",
        show: true,
      },
      {
        key: "attributes",
        show: true,
      },
      {
        key: "fees",
        show: true,
      }
    ]
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .knowbefore {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__alert {
      border-radius: $border-radius-lg * 2;
      margin-bottom: 0;
      margin-top: $grid-gutter-20 * 2;
      background-color: $selected;
      border-color: transparent;

      &-title {
        margin-bottom: 0;
        color: $gray-900;
        font-weight: $vb-font-weight-semibold;
      }

      &-link {
        color: $gray-900;
        font-weight: $vb-font-weight-semibold;
        text-decoration: underline;
      }
    }
  }

</style>